import Vue from 'vue';
import VueRouter, { RouteConfig, Route } from 'vue-router';
import TopPage from '../views/TopPage.vue';
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'TopPage',
    component: TopPage,
  },
];

const router = new VueRouter({
  mode: 'history', // "history", //mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // console.log('routing', to.fullPath, to.meta, to.matched);

  // アプリケーションパスとトップページパスを分ける前に公開していたURLをapp配下にリダイレクト
  if (to.fullPath === '/#/admin' || to.fullPath === '/#/entrance-page' || to.fullPath === '/#/entrance-page-da') {
    location.href = `/app${to.fullPath}`;
  } else {
    next();
  }
});

export default router;
